var map = {
	"./de/btn-view.png": "Il8J",
	"./en/btn-view.png": "y31Q",
	"./es/btn-view.png": "/Hn/",
	"./fr/btn-view.png": "c6vc",
	"./ja/btn-view.png": "0F0G",
	"./ko/btn-view.png": "kH2+",
	"./pt/btn-view.png": "CBxI",
	"./ru/btn-view.png": "ajGm",
	"./tc/btn-view.png": "XB0P",
	"./th/btn-view.png": "WDeE"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bJEm";